import PageTemplate from "./PageTemplate";

export default {
  render(h) {
    return (
      <PageTemplate>
        <div class="bg-gray-200 relative overflow-x-hidden">
          <div class="container px-3 lg:px-6 mx-auto">
            <div class="flex flex-wrap lg:-mx-10">
              <div class="w-full lg:w-1/2 p-10 pb-12 lg:pb-10">
                <img src="/img/about-caption-b.png" class="mx-auto mb-10" alt=""/>
                <h2 class="text-3xl font-bold text-center mb-5 leading-tight">
                  {this.$t('about_page.section_1.h1')}
                </h2>
                <p class="text-base text-gray-700 mb-10" domPropsInnerHTML={this.$t('about_page.section_1.p')}>
                </p>
                <router-link to={{name: 'CoursesPage'}} class="mb-3 lg:mb-0 px-6 p-2 lg:p-3 rounded-full text-white bg-action hover:bg-action-dark focus:outline-none focus:shadow-outline">
                  {this.$t('about_page.section_1.button')}
                  <i class="mdi mdi-arrow-right ml-5"></i>
                </router-link>
              </div>
              <div class="w-full lg:w-1/2 bg-secondary">
                <div class="lg:absolute lg:top-0 lg:bottom-0 lg:w-screen lg:bg-secondary"></div>
                <div class="relative z-10 p-10 pb-12 lg:pb-10">
                  <img src="/img/about-caption-a.png" alt="" class="mx-auto mb-10"/>
                  <h2 class="text-3xl font-bold text-center mb-5 text-white leading-tight">
                    {this.$t('about_page.section_2.h1')}
                  </h2>
                  <p class="text-white text-base mb-10">
                    {this.$t('about_page.section_2.line_1')}
                  </p>
                  <router-link to={{name: 'CoursesPage'}} class="mb-3 lg:mb-0 px-6 p-2 lg:p-3 rounded-full text-white bg-action hover:bg-action-dark focus:outline-none focus:shadow-outline">
                    {this.$t('about_page.section_2.button')}
                    <i class="mdi mdi-arrow-right ml-5"></i>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </PageTemplate>
    );
  }
}